import moment, { Moment } from "moment-timezone";
import { useTranslation } from "react-i18next";
import { classNames } from "../../helpers";

type DateHeaderCellProps = {
  date: Moment;
  isSelected: boolean;
  onSelectDay?: (date: Moment) => void;
  isDisabled?: boolean;
  className?: string;
};

const TODAY = moment();
export default function DateHeaderCell(props: DateHeaderCellProps) {
  let {
    date,
    className,
    isSelected,
    onSelectDay = () => {},
    isDisabled,
  } = props;
  let { i18n } = useTranslation();
  const isToday = date.isSame(TODAY, "day");

  return (
    <button
      disabled={isDisabled}
      onClick={() => onSelectDay(date)}
      className={classNames(
        " flex flex-col items-center justify-center gap-1 pt-2 pb-3 text-sm leading-6 border border-gray-300 shadow-sm rounded-md truncate",
        isDisabled && "cursor-not-allowed",
        !!className ? className : "w-full"
      )}
    >
      <div
        className={classNames(
          "font-medium",
          getDayNameStyle({ isDisabled, isToday, isSelected })
        )}
      >
        <span className="hidden sm:inline">
          {i18n.language === "ar" ? date.format("dddd") : date.format("ddd")}
        </span>
        <span className="sm:hidden">{date.format("dd")}</span>
      </div>
      <div
        className={classNames(
          "font-bold rounded-full w-8 h-8 flex items-center justify-center",
          getDayNumberStyle({ isDisabled, isToday, isSelected })
        )}
      >
        {date.format("D")}
      </div>
    </button>
  );
}

const getDayNameStyle = ({
  isSelected = false,
  isDisabled = false,
  isToday = false,
}) => {
  let style = "text-gray-400";
  if (isSelected) {
    style = "text-gray-700";
  } else if (isToday) {
    style = "text-gray-400";
  }
  if (isDisabled) {
    style = "text-gray-200";
  }
  return style;
};

const getDayNumberStyle = ({
  isSelected = false,
  isDisabled = false,
  isToday = false,
}) => {
  let style = "text-gray-700 bg-white";
  if (isSelected) {
    style = "text-white bg-brandblue-600";
  } else if (isToday) {
    style = "text-brandblue-600 bg-white";
  }
  if (isDisabled) {
    style = "text-gray-200 bg-white";
  }
  return style;
};
